function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Elipse_38",
  x: 0,
  y: 0,
  width: 100.898,
  height: 100.898,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Elipse_40",
  x: 54.203,
  y: 39.855,
  width: 59.449,
  height: 59.449,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Reloj",
  transform: "translate(-770.939 -356)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 770.94, 356)",
  filter: "url(#Elipse_38)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_38-2",
  "data-name": "Elipse 38",
  cx: 41.449,
  cy: 41.449,
  r: 41.449,
  transform: "translate(9 6)",
  fill: "#4290fd"
})), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_687",
  "data-name": "Trazado 687",
  d: "M837.853,449.579h0a22.115,22.115,0,0,1-1.52-2.541,80.7,80.7,0,0,1-19.379-21.721h0c-.4-.648-.8-1.32-1.2-1.993a117.647,117.647,0,0,1-12.9-34.474c-.473-2.142-.9-4.359-1.3-6.651a41.441,41.441,0,1,0,39.556,72.834c.423-.224.872-.473,1.3-.722a20.57,20.57,0,0,1-4.558-4.733Z",
  transform: "translate(0 -15.168)",
  fill: "#225ad6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_39",
  "data-name": "Elipse 39",
  cx: 35.072,
  cy: 35.072,
  r: 35.072,
  transform: "translate(786.316 368.377)",
  fill: "#66a6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_688",
  "data-name": "Trazado 688",
  d: "M941.694,419.577a1.605,1.605,0,0,1-1.594-1.594v-3.188a1.594,1.594,0,1,1,3.188,0v3.188A1.589,1.589,0,0,1,941.694,419.577Z",
  transform: "translate(-120.306 -38.447)",
  fill: "#4290fd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_689",
  "data-name": "Trazado 689",
  d: "M989.694,433.759a1.605,1.605,0,0,1-1.594-1.594,1.545,1.545,0,0,1,.224-.8l1.594-2.765a1.568,1.568,0,0,1,2.167-.573,1.59,1.59,0,0,1,.573,2.167h0l-1.594,2.765A1.551,1.551,0,0,1,989.694,433.759Z",
  transform: "translate(-156.35 -49.415)",
  fill: "#4290fd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_690",
  "data-name": "Trazado 690",
  d: "M855.67,467.088a80.7,80.7,0,0,1-19.379-21.721h0c-.4-.648-.8-1.32-1.2-1.993a117.651,117.651,0,0,1-12.9-34.474,35.065,35.065,0,0,0,35,60.729V469.6a18.252,18.252,0,0,1-1.519-2.516Z",
  transform: "translate(-19.336 -35.218)",
  fill: "#4290fd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_691",
  "data-name": "Trazado 691",
  d: "M1024.794,472.33a1.6,1.6,0,0,1-.8-2.989l2.765-1.594a1.585,1.585,0,1,1,1.594,2.74l-2.765,1.594A1.267,1.267,0,0,1,1024.794,472.33Z",
  transform: "translate(-182.706 -79.243)",
  fill: "#4290fd"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_565",
  "data-name": "Grupo 565",
  transform: "translate(792.693 388.306)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_692",
  "data-name": "Trazado 692",
  d: "M941.694,624.377a1.605,1.605,0,0,1-1.594-1.594v-3.188a1.594,1.594,0,1,1,3.188,0v3.188A1.589,1.589,0,0,1,941.694,624.377Z",
  transform: "translate(-912.999 -580.538)",
  fill: "#225ad6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_693",
  "data-name": "Trazado 693",
  d: "M887.294,611.159a1.605,1.605,0,0,1-1.594-1.594,1.544,1.544,0,0,1,.224-.8L887.518,606a1.585,1.585,0,0,1,2.74,1.594l-1.594,2.765a1.6,1.6,0,0,1-1.37.8Z",
  transform: "translate(-872.149 -570.932)",
  fill: "#225ad6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_694",
  "data-name": "Trazado 694",
  d: "M847.494,574.73a1.6,1.6,0,0,1-.8-2.989l2.765-1.594a1.585,1.585,0,1,1,1.594,2.74l-2.765,1.594A1.369,1.369,0,0,1,847.494,574.73Z",
  transform: "translate(-842.263 -544.442)",
  fill: "#225ad6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_695",
  "data-name": "Trazado 695",
  d: "M836.083,525.188h-3.188a1.594,1.594,0,1,1,0-3.188h3.188a1.605,1.605,0,0,1,1.594,1.594A1.589,1.589,0,0,1,836.083,525.188Z",
  transform: "translate(-831.3 -508.451)",
  fill: "#225ad6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_696",
  "data-name": "Trazado 696",
  d: "M850.165,472.388a1.545,1.545,0,0,1-.8-.224L846.6,470.57a1.585,1.585,0,0,1,1.594-2.74l2.765,1.594a1.569,1.569,0,0,1,.573,2.167A1.55,1.55,0,0,1,850.165,472.388Z",
  transform: "translate(-842.194 -467.607)",
  fill: "#225ad6"
})), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_697",
  "data-name": "Trazado 697",
  d: "M888.836,433.775a1.62,1.62,0,0,1-1.395-.8l-1.594-2.765a1.585,1.585,0,1,1,2.74-1.594l1.594,2.765a1.579,1.579,0,0,1-.573,2.167A1.4,1.4,0,0,1,888.836,433.775Z",
  transform: "translate(-79.404 -49.432)",
  fill: "#4290fd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_698",
  "data-name": "Trazado 698",
  d: "M919.324,478.794a1.594,1.594,0,0,0-3.188,0v10.487l-7.5,7.523a1.557,1.557,0,0,0,.05,2.242,1.594,1.594,0,0,0,2.217,0l7.971-7.971a1.585,1.585,0,0,0,.473-1.121V478.794Z",
  transform: "translate(-96.341 -86.505)",
  fill: "#4290fd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_699",
  "data-name": "Trazado 699",
  d: "M913.175,546.815l-2.416,2.416a1.609,1.609,0,0,1-2.267,0,1.578,1.578,0,0,1,0-2.242L911.481,544C912.029,544.946,912.6,545.893,913.175,546.815Z",
  transform: "translate(-96.221 -136.665)",
  fill: "#225ad6"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 770.94, 356)",
  filter: "url(#Elipse_40)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_40-2",
  "data-name": "Elipse 40",
  cx: 20.724,
  cy: 20.724,
  r: 20.724,
  transform: "translate(63.2 45.85)",
  fill: "#01003b"
})), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_700",
  "data-name": "Trazado 700",
  d: "M1022.413,578.943h0a41.7,41.7,0,0,1-17.96-23.19,56.567,56.567,0,0,1-1.519-6.053,20.71,20.71,0,0,0,24.959,32.208A43.159,43.159,0,0,1,1022.413,578.943Z",
  transform: "translate(-163.511 -140.945)",
  fill: "#040428"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_41",
  "data-name": "Elipse 41",
  cx: 15.942,
  cy: 15.942,
  r: 15.942,
  transform: "translate(838.924 406.637)",
  fill: "#004183"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_701",
  "data-name": "Trazado 701",
  d: "M1069.649,574.846a1.606,1.606,0,0,0,1.594-1.594v-.224a4.492,4.492,0,0,0-3.189-4.309v-.224a1.594,1.594,0,0,0-3.189,0v.224a4.534,4.534,0,0,0-.672,8.394l3.114,1.544a1.364,1.364,0,0,1,.623,1.818,1.325,1.325,0,0,1-1.221.747h-.473a1.382,1.382,0,0,1-1.37-1.37v-.224a1.594,1.594,0,1,0-3.188,0v.224a4.492,4.492,0,0,0,3.188,4.309v.224a1.594,1.594,0,0,0,3.189,0v-.224a4.534,4.534,0,0,0,.673-8.394l-3.114-1.544a1.364,1.364,0,0,1-.623-1.819,1.324,1.324,0,0,1,1.22-.747h.473a1.382,1.382,0,0,1,1.37,1.37v.224A1.589,1.589,0,0,0,1069.649,574.846Z",
  transform: "translate(-211.594 -153.861)",
  fill: "#dde8f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_702",
  "data-name": "Trazado 702",
  d: "M1036.877,597.29a15.729,15.729,0,0,1-4.035.523,15.949,15.949,0,0,1-13.924-23.714A41.591,41.591,0,0,0,1036.877,597.29Z",
  transform: "translate(-177.976 -159.268)",
  fill: "#01003b"
}));

var SvgTimeLeft = function SvgTimeLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113.651,
    height: 100.898,
    viewBox: "0 0 113.651 100.898",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimeLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timeLeft.4b04f9ba.svg";
export { ForwardRef as ReactComponent };